module.exports = __webpack_public_path__ + "img/changelog_icon.232c1afa.svg";